/* 有料オプション（メッセージカード / 写真送付 / 紙袋）
   bambino-publisher-custom 用

   - settings.cart_type = "page" 前提（カートドロワーなし）
   - product-form.js の submit ハンドラより先に document capture で横取りする
   - 商品ページとカートページの両方で読み込むこと
     （カートページで読み込まないと親削除時のオプション行掃除が動かない） */

(function () {
  'use strict';

  var CARD_HANDLE = 'option-message-card';
  var CARD_PROP = 'カードメッセージ';
  var OPTION_PROP = 'オプション';
  var PARENT_PROP = '対象商品';
  var SET_PROP = 'セット番号';

  function routeOf(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function trimSlash(path) {
    return path.length > 1 ? path.replace(/\/+$/, '') : path;
  }

  function isCartPage() {
    return trimSlash(window.location.pathname) === trimSlash(routeOf('cart_url', '/cart'));
  }

  function hasPubSub() {
    return typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
  }

  function money(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  function root() {
    return document.querySelector('[data-addon-root]');
  }

  /* ------------------------------------------------------------------
     1. 商品ページ
  ------------------------------------------------------------------ */

  function initProductPage() {
    var box = root();
    if (!box) return;

    var cardWrap = box.querySelector('[data-addon-card-wrap]');
    var cardText = box.querySelector('[data-addon-card-text]');
    var cardCount = box.querySelector('[data-addon-card-count]');
    var totalEl = box.querySelector('[data-addon-total]');
    var basePrice = Number(box.dataset.basePrice) || 0;

    function updateTotal() {
      if (!totalEl) return;

      var qtyInput = document.querySelector('.product-form__quantity [name="quantity"]');
      var qty = Math.max(1, Number(qtyInput && qtyInput.value) || 1);

      var total = basePrice * qty;
      Array.prototype.forEach.call(box.querySelectorAll('[data-addon-check]:checked'), function (el) {
        total += Number(el.dataset.price) || 0;
      });

      totalEl.textContent = money(total);
    }

    box.addEventListener('change', function (e) {
      if (!e.target.matches('[data-addon-check]')) return;
      if (e.target.dataset.handle === CARD_HANDLE && cardWrap) {
        cardWrap.hidden = !e.target.checked;
        if (!e.target.checked && cardText) {
          cardText.value = '';
          if (cardCount) cardCount.textContent = '0';
        }
      }
      updateTotal();
    });

    if (cardText && cardCount) {
      cardText.addEventListener('input', function () {
        cardCount.textContent = String(cardText.value.length);
      });
    }

    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'quantity') updateTotal();
    });
    document.addEventListener('input', function (e) {
      if (e.target && e.target.name === 'quantity') updateTotal();
    });

    /* バリエーション切替。PUB_SUB_EVENTS は const 宣言のため window 経由では
       参照できない。裸の識別子で参照すること。 */
    if (hasPubSub()) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (variant && typeof variant.price === 'number') basePrice = variant.price;
        updateTotal();
      });
    }

    updateTotal();
  }

  /* ------------------------------------------------------------------
     2. カート追加を横取り
  ------------------------------------------------------------------ */

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;

      var box = root();
      if (!box) return;

      var boxes = Array.prototype.slice.call(box.querySelectorAll('[data-addon-check]:checked'));
      if (!boxes.length) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      if (!idInput || !idInput.value) return;

      var qty = Math.max(1, Number(qtyInput && qtyInput.value) || 1);
      var key = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

      var btn = form.querySelector('[type="submit"]');
      var spinner = form.querySelector('.loading__spinner');
      if (btn) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
      }
      if (spinner) spinner.classList.remove('hidden');

      function buildItems(setNo) {
        var parentProps = { _addon_key: key };
        parentProps[OPTION_PROP] = boxes
          .map(function (el) {
            return el.dataset.title;
          })
          .join(' / ');
        parentProps[SET_PROP] = String(setNo);

        var hasCard = boxes.some(function (el) {
          return el.dataset.handle === CARD_HANDLE;
        });
        var cardText = box.querySelector('[data-addon-card-text]');
        if (hasCard && cardText && cardText.value.trim()) {
          parentProps[CARD_PROP] = cardText.value.trim();
        }

        var items = [{ id: Number(idInput.value), quantity: qty, properties: parentProps }];
        boxes.forEach(function (el) {
          var addonProps = { _parent_key: key };
          /* アンダースコアなしのため顧客・管理画面の双方に表示される。
             どの商品向けのオプションか判別するための表示。 */
          if (box.dataset.productTitle) addonProps[PARENT_PROP] = box.dataset.productTitle;
          addonProps[SET_PROP] = String(setNo);
          items.push({
            id: Number(el.value),
            quantity: 1,
            properties: addonProps
          });
        });
        return items;
      }

      /* セット番号はカート内の最大値+1。削除後も番号を再利用しないため重複しない。
         取得に失敗しても購入を止めず、1として続行する（表示用の番号のため）。 */
      function nextSetNo() {
        return fetch(routeOf('cart_url', '/cart') + '.js')
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            var max = 0;
            cart.items.forEach(function (item) {
              var n = Number(item.properties && item.properties[SET_PROP]);
              if (n > max) max = n;
            });
            return max + 1;
          })
          .catch(function () {
            return 1;
          });
      }

      nextSetNo()
        .then(function (setNo) {
          return fetch(routeOf('cart_add_url', '/cart/add') + '.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items: buildItems(setNo) })
          });
        })
        .then(function (res) {
          return res.json().then(function (json) {
            if (!res.ok) throw new Error(json.description || 'cart/add failed');
            return json;
          });
        })
        .then(function () {
          window.location = routeOf('cart_url', '/cart');
        })
        .catch(function (err) {
          console.error('[addon]', err);
          var host = form.closest('product-form');
          var wrap = host && host.querySelector('.product-form__error-message-wrapper');
          if (wrap) {
            wrap.removeAttribute('hidden');
            wrap.querySelector('.product-form__error-message').textContent =
              'カートに追加できませんでした。時間をおいて再度お試しください。';
          }
        })
        .finally(function () {
          if (btn) {
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('loading');
          }
          if (spinner) spinner.classList.add('hidden');
        });
    },
    true
  );

  /* ------------------------------------------------------------------
     3. カート整合チェック（親のないオプション行を削除）
  ------------------------------------------------------------------ */

  var reconciling = false;

  function reconcileAddons() {
    if (!isCartPage() || reconciling) return;
    reconciling = true;

    fetch(routeOf('cart_url', '/cart') + '.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var liveKeys = {};
        cart.items.forEach(function (item) {
          var k = item.properties && item.properties._addon_key;
          if (k) liveKeys[k] = true;
        });

        var orphans = cart.items.filter(function (item) {
          var pk = item.properties && item.properties._parent_key;
          return pk && !liveKeys[pk];
        });

        if (!orphans.length) {
          reconciling = false;
          return;
        }

        return orphans
          .reduce(function (chain, item) {
            return chain.then(function () {
              return fetch(routeOf('cart_change_url', '/cart/change') + '.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: 0 })
              });
            });
          }, Promise.resolve())
          .then(function () {
            window.location.reload();
          });
      })
      .catch(function (err) {
        console.error('[addon] reconcile', err);
        reconciling = false;
      });
  }

  function boot() {
    initProductPage();

    if (!isCartPage()) return;

    reconcileAddons();

    /* cart.js は数量変更時にリロードせずセクションを再描画するだけなので、
       cartUpdate を購読しないと親削除に追随できない。 */
    if (hasPubSub()) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        reconcileAddons();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
